import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Link } from 'react-router';
import '../../assets/scss/broox.scss';
import { AuthProvider, useAuth } from '../../contexts/AuthContext';
import { Login } from '../Login';
import { IAuthService } from '../../services/IAuthService';
import { AuthType, Instance } from '../../model/Instance';
import { InstanceNodes } from '../../components/InstanceNodes';
import { refresh, toggleMenu } from '../../services/UiService';

const App = ({ authService, clientName }: Props) => {
  useEffect(() => {
    setTimeout(() => {
      refresh();
    }, 5000);
  }, []);

  const onToggleMenu = () => {
    toggleMenu();
  }

  const Nodes = () => {
    const onLogout = async () => {
      await authService.logout();
    }

    const user = useAuth();
    if(user) {
      const auth = sessionStorage.getItem('auth');
      const instance: Instance = {
        name: `broox-studio-${clientName}`,
        description: `Instance for ${clientName}`,
        authType: AuthType.token,
        apiKey: auth ? JSON.parse(auth).token : ''
      };
      console.log('instance', instance);
      return (
        <div className="layout-wrapper layout-content-navbar">
          <div className="layout-container">
            <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
              <div className="app-brand mt-4">
                <Link to={'/'} className="app-brand-link">
                  <span className="app-brand-logo">
                    <div className="logo"></div>
                  </span>
                </Link>
                <a className="layout-menu-toggle menu-link text-large ms-auto" onClick={onToggleMenu}>
                  <i className="ti menu-toggle-icon ti-sm align-middle"></i>
                </a>
              </div>
              <div className="menu-inner-shadow"></div>
              <ul className="menu-inner py-1">
                <li className="menu-item">
                  <Link to={'/nodes'} className="menu-link">
                    <i className="menu-icon tf-icons ti ti-sitemap"></i>
                    <div>Nodes</div>
                  </Link>
                </li>
                <li className="menu-header small text-uppercase">
                  <span className="menu-header-text">USER</span>
                </li>
                <li className="menu-item">
                  <a className="menu-link" onClick={onLogout}>
                    <i className="menu-icon tf-icons ti ti-logout"></i>
                    <div>Logout</div>
                  </a>
                </li>
              </ul>
            </aside>
            <div className="layout-page">
              <div className="content-wrapper">
                <div className="container-xxl d-flex align-items-stretch flex-grow-1 p-0">
                  <div className="flex-shrink-1 flex-grow-1 container-p-x container-p-y">
                    <h5 className="pb-3 mb-3 border-bottom">Billing</h5>
                    <InstanceNodes instance={instance} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    else {
      return (
       <Navigate to={'/login'} />
      );
    }
  }

  return (
    <BrowserRouter basename={`/${clientName}`}>
      <AuthProvider authService={authService}>
        <Routes>
          <Route path="/" element={<Nodes />} />
          <Route path="/nodes" element={<Nodes />} />
          <Route path="/login" element={<Login authService={authService} />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

interface Props {
  clientName: string,
  authService: IAuthService
}

export { App };
